class HexoEarGuide extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    this.buttons = Array.from(this.querySelectorAll('[data-ear-select]'));
    this.images = Array.from(this.querySelectorAll('[data-ear-image]'));
    this.panels = Array.from(this.querySelectorAll('[data-ear-panel]'));
    this.start = this.querySelector('[data-ear-start]');
    this.reset = this.querySelector('[data-ear-reset]');
    this.status = this.querySelector('[data-ear-status]');
    const options = { signal: this.controller.signal };
    this.addEventListener('click', event => {
      const choice = event.target.closest('[data-ear-select]');
      if (choice && this.contains(choice)) this.select(choice.dataset.earSelect);
      if (event.target.closest('[data-ear-reset]')) this.select(null);
    }, options);
    this.addEventListener('keydown', event => {
      if (event.key === 'Escape' && this.selectedId) {
        event.preventDefault();
        this.select(null);
      }
    }, options);
    this.addEventListener('pointerover', event => this.warm(event.target), options);
    this.addEventListener('focusin', event => this.warm(event.target), options);
    this.select(null);
    this.dataset.enhanced = 'true';
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.requestId = (this.requestId || 0) + 1;
  }

  warm(target) {
    const button = target.closest('[data-ear-select]');
    const image = button && this.images.find(item => item.dataset.earImage === button.dataset.earSelect);
    if (image) {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      image.loading = 'eager';
    }
  }

  show(id, selectedImage = null) {
    this.buttons.forEach(button => {
      button.setAttribute('aria-pressed', String(button.dataset.earSelect === id));
      if (selectedImage && button.dataset.earSelect === id) button.dataset.jewelryVisible = 'true';
      else button.removeAttribute('data-jewelry-visible');
    });
    this.panels.forEach(panel => { panel.hidden = panel.dataset.earPanel !== id; });
    this.images.forEach(image => { image.hidden = image !== selectedImage; });
    if (this.start) this.start.hidden = id !== null;
    if (this.reset) this.reset.disabled = id === null;
  }

  async select(id) {
    const requestId = this.requestId = (this.requestId || 0) + 1;
    this.selectedId = id;
    if (this.status) this.status.textContent = '';
    this.removeAttribute('aria-busy');
    if (!id) {
      this.show(null);
      return;
    }
    const image = this.images.find(item => item.dataset.earImage === id);
    if (!image) {
      this.show(id);
      return;
    }
    this.setAttribute('aria-busy', 'true');
    if (this.status) this.status.textContent = this.dataset.loadingText || '';
    try {
      if (!image.getAttribute('src')) image.src = image.dataset.src;
      image.loading = 'eager';
      await image.decode();
      if (requestId !== this.requestId || !this.isConnected) return;
      this.show(id, image);
      if (this.status) this.status.textContent = '';
    } catch {
      if (requestId !== this.requestId || !this.isConnected) return;
      this.show(id);
      if (this.status) this.status.textContent = this.dataset.errorText || '';
    } finally {
      if (requestId === this.requestId) this.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('hexo-ear-guide')) customElements.define('hexo-ear-guide', HexoEarGuide);
